// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"461":"529ed1c2","951":"6328f2d2"}[chunkId] + ".chunk.js";
};